/**
 * package: com.inq.events
 * class: EventDispatcher
 * root Object
 * @constructor
 */
com.inq.events.EventDispatcher = function() {
	this.eventListeners = { };
};
$hxClasses.registerClass(com.inq.events.EventDispatcher, "com.inq.events.EventDispatcher");

/**
 * domEventHandler - Establishes the target value in the closure
 * This is a bit complicated but here is the explaination.
 * When we establish a handler, the HaXe creates a closure, and does a darn good job of it.
 * The closure ensures that the object instance is passed to the method handling the event.
 * This is a very good thing.
 * 
 * So if we assign a function, we assign it's method and it's object instance.
 * This way we preserve "this".  HaXe does this so we don't have to worry about such stuff :).
 * 
 * However, this is a problem when we need to acccess the "this" of the event handling.
 * Whaaaat..?
 * 
 * When an event is triggered, the DOM object that triggered the event is accessible in the "this".
 * But we want "this" to be point to our object.  Hmmmm.
 * 
 * Well, what we do is get "this" and assign it to the event object, and we assign it to item "target" and "srctarget
 * Then we pass it to the event handler.
 * 
 * What we are doing is fixing the closure instance, by putting our closure before the HaXe automatic closure.
 *
 * $type TFun([{ name => handler, t => TDynamic(null), opt => false }],TFun([{ name => ev, t => TDynamic(null), opt => false }],TEnum(Void,[])))
 * public static function domEventHandler(handler: Dynamic)
 * @public
 * @static
 * @param {null}  handler 
 * @return {TFun([{ name => ev, t => TDynamic(null), opt => false }],TEnum(Void,[]))}
 */
com.inq.events.EventDispatcher.domEventHandler = function(handler) {
	var /** @type {*} */ instance = handler.scope;
	var /** @type {*} */ method = handler.method;
	var /** @type {?} */ newClosure = function(ev) {
		var /** @type {*} */ target = this;/*  get the event target of the event;*/
		var /** @type {*} */ closure = arguments.callee;/*  This is the closure function*/
		var /** @type {*} */ object = closure.object;
		var /** @type {*} */ method1 = closure.method;
		if(ev == null) {
			var /** @type {null} */ doc = target.ownerDocument;/*  Get the document from the target*/
			var /** @type {*} */ win = doc.parentWindow?doc.parentWindow:doc.defaultView;/*  Get window from the document*/
			ev = win.Event;/*  Get the event from the window, whew, that was a lot of work*/
		}/*  If we do not have the event object, then get it from the window*//*  If we do not have the event object, then get it from the window*/
		try {
			ev.target = target;/*  Set the target in the event*/
		} catch( e ) {
		}
		try {
			ev.srcElement = target;/*  Set the srcElement in the event*/
		} catch( e ) {
		}
		/* Fire the function */
		method1.apply(object,[ev]);/*  Fire off the hander*/
	};
	
	newClosure.method = method;/*  Pass our closure the method*/
	newClosure.object = instance;/*  Pass our closure the object*/
	return newClosure;
};


/**
 * addEventListener
 *
 * Does not added more then one the unique listener.
 * Else next one the same listener will be ignored.
 *
 * @public
 * @this com.inq.events.EventDispatcher
 * @param {string}  type 
 * @param {function} listener - function that will be called on event
 * @param {boolean=} useCapture
 * @param {number=} priority
 * @param {boolean=} useWeakReference
 * @return {void}
 */
com.inq.events.EventDispatcher.prototype.addEventListener = function(type,listener,useCapture,priority,useWeakReference) {
	if (typeof listener == "function") {
		if (!this.hasEventListener(type)) {
			this.eventListeners[type] = [];
		}
		if (this._getListenerId(type, listener) == -1) {
			this.eventListeners[type].push(listener);
		}
	}
};


/**
 * willTrigger
 *
 * $type TFun([{ name => type, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * @private
 * @this com.inq.events.EventDispatcher
 * @param {string}  type 
 * @return {boolean}
 */
com.inq.events.EventDispatcher.prototype.willTrigger = function(type) {
	return false;
};


/**
 * toString
 *
 * $type TFun([],TInst(String,[]))
 * @private
 * @this com.inq.events.EventDispatcher
 * @return {string}
 */
com.inq.events.EventDispatcher.prototype.toString = function() {
	return "EventDispacher";
};


/**
 * removeEventListener
 *
 * @public
 * @this com.inq.events.EventDispatcher
 * @param {string}  type 
 * @param {function} listener - function that would be called on event
 * @param {boolean=} useCapture
 * @return {void}
 */
com.inq.events.EventDispatcher.prototype.removeEventListener = function(type,listener,useCapture) {
	if (typeof listener == "function" && this.hasEventListener(type)) {
		/** @type {number} */
		var i = this._getListenerId(type, listener);
		if (i != -1) {
			this.eventListeners[type].splice(i, 1);
			if (this.eventListeners[type].length == 0) {
				delete this.eventListeners[type];
			}
		}
	}
};


/**
 * hasEventListener
 *
 * @private
 * @this com.inq.events.EventDispatcher
 * @param {string}  type 
 * @return {boolean}
 */
com.inq.events.EventDispatcher.prototype.hasEventListener = function(type) {
	return this.eventListeners[type] != null;
};


/**
 * dispatchEvent
 *
 * @public
 * @this com.inq.events.EventDispatcher
 * @param {com.inq.events.Event}  event 
 * @return {boolean}
 */
com.inq.events.EventDispatcher.prototype.dispatchEvent = function(event) {
	if (this.hasEventListener(event.type)) {
		var returnValue; // added to cancel default behavior in IE compatibility mode
		/** @type {Array} */
		var listeners = this.eventListeners[event.type];
		/** @type {number} */
		var listenersCount = listeners.length;
		for (var i = 0; i < listenersCount; i++) {
			if(!!listeners[i] && listeners[i](event) === false) {
				returnValue = false;
			}
		}
	}
	return returnValue;
};

/**
 * Returns the index of specified listener in the list of listeners.
 * @param type
 * @param listener
 * @returns {number}
 * @private
 */
com.inq.events.EventDispatcher.prototype._getListenerId = function(type, listener) {
	/** @type {?Array} */
	var listeners = this.eventListeners[type];
	if (listeners && listeners.length > 0) {
		for (var i = 0; i < listeners.length; i++) {
			if (listener == listeners[i]) {
				return i;
			}
		}
	}
	return -1;
};

/** @private @type {null} */
com.inq.events.EventDispatcher.prototype.eventListeners = null;
/** @type {com.inq.events.EventDispatcher} */
com.inq.events.EventDispatcher.prototype.__class__ = com.inq.events.EventDispatcher;
